import { render, staticRenderFns } from "./DealWorkflowActions.vue?vue&type=template&id=35186341"
import script from "./DealWorkflowActions.vue?vue&type=script&lang=js"
export * from "./DealWorkflowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports